/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ReadOnlyAttributes.vue?vue&type=template&id=4ebd003e"
import script from "./ReadOnlyAttributes.ts?vue&type=script&lang=ts&external"
export * from "./ReadOnlyAttributes.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports